import { useState, useCallback } from "react";
import type { PaginationInstance } from "@tanstack/react-table";

type ExpandTableProps = {
  setPageSize: PaginationInstance<unknown>["setPageSize"];
  maxRows?: number;
};

export const INITIAL_ROWS = 7;
export const MAX_ROWS = 1000;

export const useExpandTable = ({
  setPageSize,
  maxRows = MAX_ROWS,
}: ExpandTableProps) => {
  const [expanded, setExpanded] = useState(false);
  const showExpand = maxRows > INITIAL_ROWS;

  const handleExpand = useCallback(() => {
    setPageSize(maxRows);
    setExpanded(true);
  }, [setPageSize, maxRows]);

  const handleCollapse = useCallback(() => {
    setPageSize(INITIAL_ROWS);
    setExpanded(false);
  }, [setPageSize]);

  return {
    expanded,
    handleCollapse,
    handleExpand,
    showExpand,
  };
};
